<!-- @format -->

<ion-button #ionButton
  class="fs-button"
  strong="true"
  [expand]="blocked ? 'block' : null"
  [color]="color"
  [fill]="buttonStyle === 'clear' ? 'clear' : buttonStyle === 'outline' ? 'outline' : 'solid'"
  [type]="type"
  [ngClass]="{
    'fs-button--primary': buttonStyle === 'primary',
    'fs-button--outline': buttonStyle === 'outline',
    'fs-button--clear': buttonStyle === 'clear',
    'fs-button--large': size === 'large',
    'fs-button--icon-only': iconOnly,
    'ion-text-nowrap': !canTextWrap,
    'ion-text-wrap': canTextWrap,
  }"
  [disabled]="disabled"
  [style.--min-width]="iconOnly ? minWidth : null"
  >
  <div class="fs-button__content">
    @if (loading) {
      <ion-spinner slot="start" name="crescent"></ion-spinner>
    }
    <ng-content></ng-content
      >@if (icon) {
      <ion-icon
        [style]="iconOnly ? 'position: relative; top: -3px;' : 'margin: -5px 0 -5px 10px; position: relative; top: -3px;'"
        [slot]="iconOnly ? 'icon-only' : 'end'"
        [name]="icon"
      ></ion-icon>
    }
  </div>
</ion-button>
